import React, {Component} from 'react'
import {connect} from 'react-redux'
import {updateValues} from '../../../routers/data'
import {updateSettings, fetchAvailableDates} from '../../../routers/settings'
import PropTypes from "prop-types";

const Item = ({value, onClick, children, checked}) => {
  const classname = (checked)?'select':''
  return (
    <li className={classname} onClick={() => onClick(value)}>{children}</li>
  )
}

class formOrigin extends Component{
  static contextTypes = {
    router: PropTypes.object
  }

  onClickOrigin = (value) => {
    this.props.updateValues({origin: value, destiny: undefined, departuredate: undefined, returndate: undefined})
  }

  onClickDestinys = async (value) => {
    await this.props.updateValues({destiny: value, departuredate: undefined, returndate: undefined})
    this.props.fetchAvailableDates(this.props.values, this.props.settings)
  }

  render(){
    const langUrl = this.context.router.route.location.pathname.split('/')[1]
    const { languages } = this.props.settings
    const langPlace = languages[langUrl].fastbooking.origin

    const {enable, updateSettings} = this.props
    const {travels} = this.props.settings
    const footerProps = (enable) ? {onClick: () => updateSettings({'tab': 1})}: undefined
    const nextProps = (enable) ? {className: 'next'}: {className: 'next-disabled'}
    const {origin, destiny} = this.props.values

    const destinations = (origin!==undefined)?travels[origin].destinations:[]

    return (
			<div className='container-fluid'>

        <div className='panel-origin row'>
            <div className='panel-origin-origin col-md-6 col-sm-6 col-xs-12 no-padding' >

              <p className='title'>{langPlace.origin}</p>

              <ul>
                {travels.map((item, index) => <Item key={index} value={index} checked={index===origin}
                                                       onClick={this.onClickOrigin}>{item.name}</Item>)}
              </ul>

            </div>

            <div className='panel-origin-destiny col-md-6 col-sm-6 col-xs-12 no-padding' >

              <p className='title'>{langPlace.destiny}</p>
              <ul>
                {destinations.map((item, index) => <Item key={index} value={index} checked={index===destiny}
                                                  onClick={this.onClickDestinys}>{item.name}</Item>)}
              </ul>

            </div>
        </div>
        <div className='footer row' {...footerProps}>
          <span {...nextProps}>{langPlace.confirmrute}<i className="fa fa-chevron-circle-right" aria-hidden="true"/></span>
        </div>

		  </div>
    )
  }
}

export default connect(
	(state) => ({settings: state.settings, values: state.data.values}),
  {updateSettings, updateValues, fetchAvailableDates}
)(formOrigin)



// WEBPACK FOOTER //
// ./src/shared/routes/components/fastbooking/panelOrigin.js